"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftRailButton = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
require("./styles.less");
function LeftRailButton(props) {
    return (React.createElement("a", { className: "c-left-rail-button " + (props.colored ? 'c-left-rail-button--colored' : '') + " " + props.className, href: props.url, onClick: props.onClick, target: props.colored ? '_blank' : '_self' }, props.title));
}
exports.LeftRailButton = LeftRailButton;
